import React, { useState, useEffect } from 'react'

const Backdrop = ({ children, show, position='top' }) => {
  const [ state, setState ] = useState()

  useEffect(() => {
    setState('fade')
    if (show)
      setTimeout(() => setState('show'), 10)
    else
      setTimeout(() => setState(null), 310)
  }, [ show ])

  const stateNumber = Number(state == 'show')

  const innerStyle = position == 'center'
  ? { top: '50%', transform: `translateY(-50%) scale(${stateNumber})` }
  : { [position]: 0, transform: `scale(${stateNumber})` }

  return (
    state &&
    <div className="position-absolute top-0 start-0 w-100 h-100" style={{
      backgroundColor: 'rgba(var(--bs-white-rgb), 0.65)',
      WebkitBackdropFilter: 'blur(1rem)',
      backdropFilter: 'blur(1rem)',
      opacity: stateNumber,
      transition: 'opacity 0.3s',
    }}>
      <div
        className="position-absolute w-100 my-3 my-sm-4 px-3 px-sm-4"
        style={{
          ...innerStyle,
          transformOrigin: position,
          transition: 'transform 0.3s',
        }}
        role="alert"
      >
        {!!show && children}
      </div>
    </div>
  )
}

export default Backdrop
